/* istanbul ignore file */
import { FormSection, MediumFormRow, BigFormRow } from 'framework/ui/layout';
import { TextArea } from 'framework/form';
import CareerDevelopmentReviewAttachmentUploaderInput from 'domain/people/career/development/shared/input/CareerDevelopmentReviewAttachmentUploaderInput';
import useEarlyStartedIntitialization from 'domain/people/career/development/createupdate/earlyStartedInitialization';
import EarlyStartedHandler from 'domain/people/career/development/createupdate/EarlyStartedHandler';

const CareerDevelopmentReviewForm = () => {
  const { isEarlyStarted, nextReviewDate } = useEarlyStartedIntitialization();

  return (
    <>
      <EarlyStartedHandler nextReviewDate={nextReviewDate} isEarlyStarted={isEarlyStarted} />
      <FormSection title="Career development review information">
        <MediumFormRow>
          <TextArea
            label="Completed assessments or examples of work"
            source="completedAssessments"
            tooltip="Provide links to the tickets containing the results of your qualification assessments or examples of work."
          />
        </MediumFormRow>

        <MediumFormRow>
          <TextArea
            label="Reason for early process start"
            source="earlyStartReason"
            isVisible={data => data.isEarlyStarted}
          />
        </MediumFormRow>
        <BigFormRow>
          <CareerDevelopmentReviewAttachmentUploaderInput label="Attachment" source="attachmentsIds" />
        </BigFormRow>
      </FormSection>
    </>
  );
};

export default CareerDevelopmentReviewForm;
